import React from 'react'
import { Header, Container } from 'semantic-ui-react'
import './About.less'

import Layout from '../components/Layout'
import LandscapeIcon from '../components/icons/LandscapeIcon'
import TransparencyIcon from '../components/icons/TransparencyIcon'
import NetworkIcon from '../components/icons/NetworkIcon'
import StallIcon from '../components/icons/StallIcon'
import ContactCard from '../components/ContactCard'
import BackgroundImage from '../assets/images/pasture.jpg'

const steps = [
  {
    title: "Working Landscapes",
    description: "Being good stewards of the land means using the land in ways that work for both people and for the planet. This means producing food in a way that enables our environment to continue nourishing us for generations and generations.",
    icon: <LandscapeIcon />
  }, {
    title: "Strength in Numbers",
    description: "Scaling up to meet the needs of our growing population does not have to depend solely on a few large actors to supply our caloric needs, i.e. actors using highly mechanized, linear production methods, that are dependent on external inputs. Scaling up can mean creating a distributed network that enables the multiplication of local farming systems. These smaller, self-sufficient systems can nourish their communities through a diverse and nutrient dense array of crops. ",
    icon: <NetworkIcon />
  }, {
    title: "Transparency",
    description: <span>In order to be able to <a href='/food-principles' className='bold'>express our values</a> through our food choices, we need to know where our food comes from and how it is grown. Today, food that's produced using inhumane and environmentally destructive methods depends on a lack of transparency.</span>,
    icon: <TransparencyIcon />
  }, {
    title: "The True Cost of Real Food",
    description: "We need a value chain that rewards participants fairly and captures the real costs of food production. The idea that we can have whatever we want, instantaneously, and at low cost is not sustainable and does not reflect the true constraints of nature.",
    icon: <StallIcon />
  }
]

const renderStep = (step, i) => {
  return (
    <div className="step-container" key={i}>
      {/* <div className="step-number">{i + 1}</div> */}
      <div>{step.icon}</div>
      <div className="step-content">
        {
          step.title &&
          <Header as="h5" className="san-serif">
            {step.title}
          </Header>
        }
        <p>{step.description}</p>
      </div>
    </div>
  )
}

const heroStyle = {
  backgroundImage: `url(${BackgroundImage})`,
  backgroundSize: `cover`
}

const About = () => {
  const johannesImage = "https://media.licdn.com/dms/image/C5603AQFcHsYRpxkWZA/profile-displayphoto-shrink_800_800/0?e=1544659200&v=beta&t=owBAW-AhL8jFihAJH_p7l_QUzA6ZEXnJVbPvVX374EQ"
  const montanaImage = "https://media.licdn.com/dms/image/C5603AQFXfitvLTKkTg/profile-displayphoto-shrink_200_200/0?e=1544659200&v=beta&t=Fxa6JzXCvOukh-ONVzzr6oNg5wiDxl1iXujNB5Qu2rI"
  const lukasImage = "https://media.licdn.com/dms/image/C4E03AQF6ul0zZ_tllA/profile-displayphoto-shrink_800_800/0?e=1544659200&v=beta&t=Gwp0DJM4ePmnCAVpOoh__gl5uiXi4mi-2_awj69I_pg"
  const willImage = "https://media.licdn.com/dms/image/C5603AQGU3xOXDd57Gg/profile-displayphoto-shrink_800_800/0?e=1544659200&v=beta&t=qoEGePZruDWeek2w91de01q7BK0T_7U_epvVn-RPOUs"

  return (
    <Layout>
      <Container>
        <section className='hero'>
          <div className='background-image' style={heroStyle}></div>
        </section>
        <section className='mission inverse'>
          <div className='content-container'>
            <Header as='h1' className='bold'>Mission</Header>
            <p>
              We aim to strengthen our local food systems by making it easier for all of us
              to <span className='bold'>eat seasonally</span> and discover nourishing
              food grown in ways that are <span className='bold'>regenerative</span> rather than
              extractive.
            </p>
            <p>
              We’re optimistic about a future where the best food <span className='bold'>
                for people</span> is also what's best for <span className='bold'>the environment </span>
                and <span className='bold'>our communities</span>.
            </p>
          </div>
        </section>
        <section className='philosophies'>
          <Header as='h1' className='bold green'>Philosophies</Header>
          <div className='content'>
            { steps.map((s, i) => renderStep(s, i)) }
          </div>
        </section>
        <section className='people inverse'>
          <div className='content-container'>
            <Header as='h1' className='bold'>People</Header>
            <p>
              We are constantly learning about how we can better accomplish our mission. We love
              doing that by talking to the people out there growing, eating, cooking, and sharing
              real food. So please reach out!
            </p>
            <p>
              You can reach us at our <span className='bold'>first name</span> @ <span className='bold'>oclo.io</span>
            </p>
            <div className='content'>
              <ContactCard image={johannesImage} title={"Johannes Herrmann"} url={"https://www.linkedin.com/in/johannesherrmann/"}/>
              <ContactCard image={lukasImage} title={"Lukas Gräf"} url={"https://www.linkedin.com/in/lgraef/"}/>
              <ContactCard image={montanaImage} title={"Montana Scher"} url={"https://www.linkedin.com/in/montanascher/"}/>
              <ContactCard image={willImage} title={"Will Culler-Chase"} url={"https://www.linkedin.com/in/williamcullerchase/"}/>
            </div>
          </div>
        </section>
        <section>
        </section>
      </Container>
    </Layout>
  )
}

export default About;
